module.exports = __webpack_public_path__ + "static/media/highlight-1.c3294aad.PNG";